// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_b9-2";
export var aiChatCartContainerExit = "_b9-4";
export var aiChatContainerLarge = "_b9-0";
export var aiChatContainerSmall = "_b9-1";
export var aiChatIcon = "_b9-6";
export var slideInFromRight = "_b9-3";
export var slideOutToRight = "_b9-5";